import { render } from "./GridMobile.vue?vue&type=template&id=23d46a06&scoped=true"
import script from "./GridMobile.vue?vue&type=script&lang=js"
export * from "./GridMobile.vue?vue&type=script&lang=js"

import "./GridMobile.vue?vue&type=style&index=0&id=23d46a06&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23d46a06"]])

export default __exports__